import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { initFilestackClient } from './initFilestackClient';

/**
 * Upload a scorm zip file to Filestack using Filestack.upload. This is a direct
 * File upload without using the Filestack Picker UI
 *
 * @param {File} file The scorm file to be uploaded
 * @return {Promise<object>} An object representing the filestack image record
 * with the keys transformed to a format that our backend expects (see: getImageData)
 */
async function filestackFileUpload(file, progressCallback) {
  const { client, storeOptions } = await initFilestackClient(() =>
    request.get(routes.SCORM_UPLOAD_OPTIONS),
  );
  const upload = await client.upload(
    file,
    {
      onProgress: progressCallback,
    },
    storeOptions,
  );
  return upload;
}

export async function scormUploadToFilestack(file, progressCallback) {
  const filestackResponse = await filestackFileUpload(file, progressCallback);
  return filestackResponse;
}
